export default import.meta.ROLLDOWN_FILE_URL_nRpAQn4Mxa1sF7hwhg4BmQ